import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles.css';

/**
 * The provider is inside `BrowserRouter` so the player can use router context if a surface wants
 * it, and `App` renders `<Routes>` inside `<PlayerProvider>` — which is what keeps playback alive
 * across navigation. The nesting order here is load-bearing; swapping it reintroduces the bug.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
